import Maps from "@/components/Elemnt/Maps/Maps";
import { useParams } from "react-router";

const MapsPage = () => {
  const { appToken = "" } = useParams();
  return <Maps appToken={appToken} />;
};

export default MapsPage;
